import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalContentProps,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  chakra,
} from '@chakra-ui/react';

type Props = {
  children: any;
  title?: string;
  isOpen: boolean;
  closeOnEsc?: boolean;
  showCloseButton?: boolean;
  onClose: () => any;
  footer?: React.ReactNode;
};

function Basic({
  children,
  title,
  isOpen,
  onClose,
  closeOnEsc = false,
  showCloseButton = true,
  footer,
  ...modalContentProps
}: Props & ModalContentProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnEsc={closeOnEsc}>
      <ModalOverlay />
      <ModalContent
        width={{ base: '100%', md: 'auto' }}
        pt={8}
        pb={8}
        maxWidth={{ base: '100%', md: '7xl' }}
        {...modalContentProps}
      >
        {title && (
          <ModalHeader>
            <chakra.h4>{title}</chakra.h4>
          </ModalHeader>
        )}
        {showCloseButton && <ModalCloseButton />}
        <ModalBody>{children}</ModalBody>
        {footer && <ModalFooter>{footer}</ModalFooter>}
      </ModalContent>
    </Modal>
  );
}

export default Basic;
